<template>
  <div class="tab-container">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="个人信息" name="home">
        <div style="margin-top: 10px">
          <el-card style="margin: 5px;">
            <el-form :model="employeeData" label-width="110px">
              <el-row style="margin-top: 20px;">
                <el-col :span="12">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="工号：" required>
                        <el-input v-model="employeeData.employee_no" placeholder="工号" disabled/>
                      </el-form-item>
                      <el-form-item label="姓名：" required>
                        <el-input v-model="employeeData.employee_name" placeholder="姓名"
                                  disabled/>
                      </el-form-item>
                      <el-form-item label="性别：" required>
                        <el-input v-model="employeeData.sex" placeholder="性别"
                                  disabled/>
                      </el-form-item>
                      <el-form-item label="职位：" required>
                        <el-select v-model="employeeData.position_id" placeholder="职位" disabled>
                          <el-option v-for="item in positionList" :key="item.id" :label="item.name"
                                     :value="item.id"/>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="职级：" required>
                        <el-input v-model="employeeData.position_level" placeholder="职级"
                                  disabled/>
                      </el-form-item>
                      <el-form-item label="学历：">
                        <el-input v-model="employeeData.education" placeholder="学历" disabled/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <kf-image-upload class="employee-photo" v-model="employeeData.photo"
                                     :init-file="employeeData.photo_obj"
                                     @fileChange="photoChange" :limit="1" :disabled="true"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="部门：" required>
                    <el-cascader v-model="employeeData.department_ids" :options="departmentList"
                                 :props="optionProps" style="width: 100%" disabled/>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
        </div>
      </el-tab-pane>
      <el-tab-pane label="假期余额" name="message">
        <div>
          <el-scrollbar>
            <el-row>
              <label class="first-label">年假余额：</label>
              <label class="first-label">剩余 {{ annualLeaveBalance }} 天</label>
              <div v-show="isForeverLeaveShow" class="first-label" style="width:400px;margin-left: 30%">
                <label>永久年假余额：</label>
                <label>剩余 {{ forever_balance }} 天</label>
              </div>
            </el-row>
            <el-card style="margin: 5px;">
              <el-row>
                <el-col :span="12">
                  <el-row :span="24">
                    <el-form style="width: 350px" label-width="120px">
                      <el-form-item>
                        <el-text style="font-weight: bold">去年：</el-text>
                      </el-form-item>
                      <el-form-item label="发放(天)：">
                        <el-input v-model="lastAnnualYear.days" disabled/>
                      </el-form-item>
                      <el-form-item label="已使用(天)：">
                        <el-input v-model="lastAnnualYear.use_day" disabled/>
                      </el-form-item>
                      <el-form-item label="剩余(天)：">
                        <el-input v-model="lastAnnualYear.balance" disabled/>
                      </el-form-item>
                      <el-form-item label="有效期：">
                        <el-input v-model="lastAnnualYear.expiring_date" disabled/>
                      </el-form-item>
                    </el-form>
                  </el-row>
                </el-col>
                <el-col :span="12">
                  <el-row :span="24">
                    <el-form style="width: 350px" label-width="120px">
                      <el-form-item>
                        <el-text style="font-weight: bold">今年：</el-text>
                      </el-form-item>
                      <el-form-item label="发放(天)：">
                        <el-input v-model="currentAnnualYear.days" disabled/>
                      </el-form-item>
                      <el-form-item label="已使用(天)：">
                        <el-input v-model="currentAnnualYear.use_day" disabled/>
                      </el-form-item>
                      <el-form-item label="剩余(天)：">
                        <el-input v-model="currentAnnualYear.balance" disabled/>
                      </el-form-item>
                      <el-form-item label="有效期：">
                        <el-input v-model="currentAnnualYear.expiring_date" disabled/>
                      </el-form-item>
                    </el-form>
                  </el-row>
                </el-col>
              </el-row>
            </el-card>
            <el-row>
              <label class="first-label">调休余额:</label>
              <label class="first-label">剩余 {{ compensatoryBalance }} 天</label>
            </el-row>
            <el-card style="margin: 5px">
              <el-row>
                <el-col :span="12">
                  <el-row :span="12">
                    <el-form style="width: 350px" label-width="120px">
                      <el-form-item>
                        <el-text style="font-weight: bold">去年：</el-text>
                      </el-form-item>
                      <el-form-item label="发放(小时)：">
                        <el-input v-model="lastCompensatoryYear.hours" disabled/>
                      </el-form-item>
                      <el-form-item label="已使用(小时)：">
                        <el-input v-model="lastCompensatoryYear.use_hours" disabled/>
                      </el-form-item>
                      <el-form-item label="剩余(小时)：">
                        <el-input v-model="lastCompensatoryYear.balance" disabled/>
                      </el-form-item>
                      <el-form-item label="有效期：">
                        <el-input v-model="lastCompensatoryYear.expiring_date" disabled/>
                      </el-form-item>
                    </el-form>
                  </el-row>
                </el-col>
                <el-col :span="12">
                  <el-row :span="12">
                    <el-form style="width: 350px" label-width="120px">
                      <el-form-item>
                        <el-text style="font-weight: bold">今年：</el-text>
                      </el-form-item>
                      <el-form-item label="发放(小时)：">
                        <el-input v-model="currentCompensatoryYear.hours" disabled/>
                      </el-form-item>
                      <el-form-item label="已使用(小时)：">
                        <el-input v-model="currentCompensatoryYear.use_hours" disabled/>
                      </el-form-item>
                      <el-form-item label="剩余(小时)：">
                        <el-input v-model="currentCompensatoryYear.balance" disabled/>
                      </el-form-item>
                      <el-form-item label="有效期：">
                        <el-input v-model="currentCompensatoryYear.expiring_date" disabled/>
                      </el-form-item>
                    </el-form>
                  </el-row>
                </el-col>
              </el-row>
            </el-card>
            <el-row>
              <label class="first-label">育儿假:</label>
              <label class="first-label">剩余 {{ parentalLeave.balance }} 天</label>
            </el-row>
            <el-card style="margin: 5px">
              <el-row>
                <el-col :span="12">
                  <el-row :span="12">
                    <el-form style="width: 350px" label-width="120px">
                      <el-form-item label="发放(天)：">
                        <el-input v-model="parentalLeave.days" disabled/>
                      </el-form-item>
                      <el-form-item label="剩余(天)：">
                        <el-input v-model="parentalLeave.balance" disabled/>
                      </el-form-item>
                    </el-form>
                  </el-row>
                </el-col>
                <el-col :span="12">
                  <el-row :span="12">
                    <el-form style="width: 350px" label-width="120px">
                      <el-form-item label="已使用(天)：">
                        <el-input v-model="parentalLeave.use_day" disabled/>
                      </el-form-item>
                      <el-form-item label="有效期：">
                        <el-input v-model="parentalLeave.expiring_date" disabled/>
                      </el-form-item>
                    </el-form>
                  </el-row>
                </el-col>
              </el-row>
            </el-card>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="职级信息" name="settings">
        <template>
          <div class="block">
            <el-scrollbar>
              <el-timeline>
                <el-timeline-item
                    v-for="(activity, index) in activities"
                    :key="index"
                    :icon="activity.icon"
                    :type="activity.type"
                    :color="selectedIndices.includes(index) ? '#68b7ff' : activity.color"
                    :size="activity.size"
                    :timestamp="activity.timestamp"
                    :style="{ '--timeline-color': selectedIndices.includes(index) ? '#68b7ff' : activity.color }">

                  <div class="info-block">
                    <div class="title-promotion-block" :class="{ 'selected-title': selectedIndices.includes(index)}">
                      <p><strong> {{ activity.title }} </strong></p>
                      <p style="margin-left: 45%"><strong> {{ activity.promotionDate }}</strong></p>
                    </div>

                    <label style="margin:10px 5px 10px;font-weight: bold">待遇职责：</label>
                    <el-card style="margin:5px;padding: 5px">
                      <el-form label-width="140px" v-for="(item, index) in activity.dutyData" :key="index">
                        <el-col :span="10">
                          <el-form-item label="工资范围：">
                            <el-input v-model="item.salary_range" :placeholder="item.salary_range" disabled></el-input>
                          </el-form-item>
                        </el-col>
                        <el-row>
                          <el-col :span="10">
                            <el-form-item label="项目奖金：">
                              <el-input v-model="item.project_bonus" :placeholder="item.bonus_point"
                                        disabled></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="10">
                            <el-form-item label="额外补贴与奖励:">
                              <el-input v-model="item.extra_allowance" :placeholder="item.extra_allowance"
                                        disabled></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="20">
                            <el-form-item label="工作内容：">
                              <el-input v-model="item.work_content" :placeholder="item.work_content" :rows="5"
                                        type="textarea"
                                        disabled></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-form>
                    </el-card>

                    <label style="margin: 5px;font-weight: bold">晋升条件：</label>
                    <el-card style="margin: 5px;padding: 5px">
                      <el-row>
                        <el-col v-for="(criteria, criteriaIndex) in activity.minYear" :key="criteriaIndex">
                          <el-row :span="24">
                            <el-col :span="10">
                              <el-form-item label="最低从业年限：" label-width="140px">
                                <el-input v-model="criteria.min_year" :placeholder="criteria.min_year" disabled/>
                              </el-form-item>
                            </el-col>
                            <el-col :span="14" style="display: flex; justify-content: flex-end;">
                              <el-form-item style="padding-right: 10px">
                                <el-checkbox v-model="criteria.achieved" disabled>达成</el-checkbox>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                      <div>
                        <el-row>
                          <el-col :span="4">
                            <el-form-item label-width="140px" label="晋升前置条件："/>
                          </el-col>
                          <el-col :span="20">
                            <el-table :data="activity.promotionCriteria" style="width: 100%" :show-header="false">
                              <el-table-column v-slot="scope" prop="criteria">
                                <el-input v-model="scope.row.criteria" :placeholder="scope.row.criteria" disabled/>
                              </el-table-column>
                              <el-table-column width="100">
                                <template v-slot="scope">
                                  <div style="display: flex; justify-content: flex-end; ">
                                    <el-checkbox v-model="scope.row.achieved" disabled>达成
                                    </el-checkbox>
                                  </div>
                                </template>
                              </el-table-column>
                            </el-table>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="4">
                            <el-form-item label-width="140px" label="考核前置条件："/>
                          </el-col>
                          <el-col :span="20">
                            <el-table :data="activity.examCriteria" style="width: 100%" :show-header="false"
                                      :border="false">
                              <el-table-column v-slot="scope" prop="criteria">
                                <el-input v-model="scope.row.criteria" :placeholder="scope.row.criteria" disabled/>
                              </el-table-column>
                              <el-table-column width="100">
                                <template v-slot="scope">
                                  <div style="display: flex; justify-content: flex-end; ">
                                    <el-checkbox v-model="scope.row.achieved" disabled>达成
                                    </el-checkbox>
                                  </div>
                                </template>
                              </el-table-column>
                            </el-table>
                          </el-col>
                        </el-row>
                      </div>
                    </el-card>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </el-scrollbar>
          </div>
        </template>
      </el-tab-pane>
      <el-tab-pane label="打卡记录" name="attendanceRecord">
        <FrameQuery ref="frameQuery"  component-param="attendance_personal_daily_result"></FrameQuery>
      </el-tab-pane>
      <el-tab-pane label="月度考勤" name="attendance">
        <PersonalAttendanceDetail/>
      </el-tab-pane>
      <el-tab-pane label="薪资信息" name="salary">
        <PersonalSalaryDetail/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import PersonalAttendanceDetail from "@/views/applications/employee/PersonalAttendanceDetail.vue";
import PersonalSalaryDetail from "@/views/applications/employee/PersonalSalaryDetail.vue";

export default {
  name: "PersonalCenter",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  components: {
    PersonalAttendanceDetail,PersonalSalaryDetail
  },
  data() {
    return {
      activeTab: 'home',
      optionProps: {
        value: 'id',
        label: 'name'
      },
      employeeData: {},
      positionList: [],
      departmentList: [],

      lastYear: {},
      currentCompensatoryYear: {},
      lastCompensatoryYear: {},
      currentAnnualYear: {},
      lastAnnualYear: {},
      forever_balance: '',
      isForeverLeaveShow: false,
      annualLeaveBalance: 0,
      compensatoryBalance: 0,
      parentalLeave: {},

      check: false,
      activities: [],
      selectedIndex: -1,
      selectedIndices: []
    };
  },
  methods: {
    handleTabClick(tab, event) {
      console.log('Tab clicked:', tab.name);
      // 可以在这里处理标签页切换的逻辑
    },
    async getInfoData() {
      let dbInfo = await this.$http('userCenterService.getInfoById');
      if (dbInfo) {
        this.employeeData = dbInfo;
      }
    },
    async getPositionList() {
      this.positionList = await this.$http('employeeHRService.getEmpPositionList');
    },
    async getDepartmentList() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
      // console.log(this.departmentList);
    },
    async photoChange(ids) {
      // console.log(ids)
      if (ids.length <= 0) {
        this.employeeData.photo = ''
        return
      }
      this.employeeData.photo = ids[0];
    },

    //   回显数据
    async getLeaveData() {
      let compensatoryData = await this.$http('userCenterService.getCompensatoryLeaveData');
      let annualData = await this.$http('userCenterService.getAnnualLeaveData');
      let dailyHours = await this.$http('userCenterService.getDailyMinutes') / 60;
      this.parentalLeave = await this.$http('userCenterService.getParentalLeaveData');

      if (compensatoryData) {
        this.lastCompensatoryYear = (Array.isArray(compensatoryData.lastYear) && compensatoryData.lastYear.length > 0) ? compensatoryData.lastYear[0] : null;
        this.currentCompensatoryYear = (Array.isArray(compensatoryData.currentYear) && compensatoryData.currentYear.length > 0) ? compensatoryData.currentYear[0] : null;

        const currentBalance = Number(this.currentCompensatoryYear?.balance) || 0;
        const lastBalance = Number(this.lastCompensatoryYear?.balance) || 0;
        this.compensatoryBalance = ((currentBalance + lastBalance) / dailyHours);
      }

      if (annualData) {
        this.lastAnnualYear = (Array.isArray(annualData.lastYear) && annualData.lastYear.length > 0) ? annualData.lastYear[0] : null;
        this.currentAnnualYear = (Array.isArray(annualData.currentYear) && annualData.currentYear.length > 0) ? annualData.currentYear[0] : null;

        const currentAnnualBalance = Number(this.currentAnnualYear?.balance) || 0;
        const lastAnnualBalance = Number(this.lastAnnualYear?.balance) || 0;

        this.annualLeaveBalance = currentAnnualBalance + lastAnnualBalance;
      }

      this.annualLeaveBalance = this.annualLeaveBalance || 0;
      this.compensatoryBalance = this.compensatoryBalance || 0;

      this.forever_balance = await this.$http("userCenterService.getForeverAnnualLeave");
      this.isForeverLeaveShow = !!this.forever_balance;
    },

    // 请求职级数据
    async fetchRankData() {
      try {
        this.activities = await this.$http("userCenterService.getLevelData")
        await this.setCurrentRankColor();

      } catch (error) {
        console.error('获取职级数据失败', error);
      }
    },

    async setCurrentRankColor() {
      try {
        let currentRank = await this.$http("userCenterService.getCurrentLevelByUserName");
        this.selectedIndices = [];

        for (let i = 0; i < currentRank.length; i++) {
          let index = this.activities.findIndex(activity => activity.title.startsWith(currentRank[i]));
          if (index !== -1) {
            this.selectedIndices.push(index);
          }
        }
        console.log("this.selectedIndices", this.selectedIndices)
      } catch (error) {
        console.error('获取当前职级失败', error);
      }
    }

  },
  created() {
    this.getInfoData();
    this.getDepartmentList();
    this.getPositionList();
    this.getLeaveData();
    this.fetchRankData();
  },

};
</script>

<style lang="less">
.tab-container {
  padding: 20px;
}

.el-timeline {
  --el-timeline-node-color: var(--el-border-color-light);
}

.block {
  padding: 20px;
}

.info-block {
  margin-bottom: 20px;
}

.selected-title {
  color: #68b7ff;
}

.title-promotion-block {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin: 0 5px;
}

.criteria-label {
  font-weight: bold;
  margin-bottom: 5px;
}

.promotion-criteria-table {
  display: flex;
  flex-direction: column;
}

.promotion-criteria-row {
  display: flex;
  margin-bottom: 10px;
}

.promotion-criteria-label {
  width: 250px;
  font-weight: bold;
}

.promotion-criteria-checkbox {
  margin-left: 10px;
}

.el-table {
  --el-table-border-color: transparent;
}

.el-table td.el-table__cell {
  border-bottom: none;
}

.el-table .cell {
  padding: 0 10px 0 0;
}

.first-label {
  margin: 10px 10px 5px 5px;
  font-weight: bold;
  font-size: 15px;
}

</style>